










































import VueOptions from '@utils/VueOptions'
settings =
  name: 'CSVImporter'

  vue:
    props: ['data']

    data: ->
      type: 'google_sheet_url'
      sheetLinks:
        [
          '1VZDCmEJ_1awAxjA6MM1C6qi1FzmDI0s5AryxR-r3kg0/edit#gid=0',
          '1VZDCmEJ_1awAxjA6MM1C6qi1FzmDI0s5AryxR-r3kg0/edit#gid=1903192301'
        ]

    methods:
      hiSelectGoogleSheetURLBox: -> 
        @data.csv_string = ''
        @type = 'google_sheet_url'

      hiSelectPasteBox: ->
        @data.google_sheet_url = ''
        @type = 'paste'

export default VueOptions.vue settings
